<div class="flex-content">
  <div class="content col-sm container-fluid">

    <div class="modal fade" id="selectedImageModal" >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img *ngIf="selectedImage" default="./../../../../assets/imgs/no_image.jpg" [srcset]="imgPath + selectedImage">
          </div>
        </div>
      </div>
    </div>

    <div *ngFor="let data of lifes$ | async" class="row life-row">
    <!-- <div class="row life-row"> -->

      <div class="col-12 year display-4" [id]='data[0].year'>
        {{data[0].year}}
      </div>

      <div *ngFor="let lifes of data" class="life-row col-12">

        <h3 class="life-title">{{lifes.title}}</h3>


        <div class="life-content">
          <div class="data-date">
            <h2 class="text-center date">{{lifes.day}}</h2>
            <h5 class="text-center date">{{lifes.month | numToMonth }}</h5>
            <p class="text-center date">{{lifes.year}}</p>
          </div>
          <div class="card-columns">
              <div *ngIf="lifes.link" class="card">
                <img videoThumbnail [videoUrl]='lifes.link' 
                    sizes="(min-width:990px) 300px, 800px">

              </div>
              <div *ngIf="lifes.smallImg1" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg1" 
                      [src] ="imgPath + lifes.smallImg1" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg1)>
              </div>
              <div *ngIf="lifes.smallImg2" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg2" 
                      [src] ="imgPath + lifes.smallImg2" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg2)>
              </div>
              <div *ngIf="lifes.smallImg3" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg3" 
                      [src] ="imgPath + lifes.smallImg3" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg3)>
              </div>
              <div *ngIf="lifes.smallImg4" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg4" 
                      [src] ="imgPath + lifes.smallImg4" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg4)>
              </div>
              <div *ngIf="lifes.smallImg5" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg5" 
                      [src] ="imgPath + lifes.smallImg5" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg5)>
              </div>
              <div *ngIf="lifes.smallImg6" class="card">
               <img default="./../../../../assets/Contents/imgs/no_image.jpg"
                      class="card-img img-fluid" 
                      [srcset] ="imgPath + lifes.smallImg6" 
                      [src] ="imgPath + lifes.smallImg6" 
                    data-toggle="modal" data-target="#selectedImageModal"
                    (click)=setSelectedImage(lifes.smallImg6)>
              </div>
          </div>
        </div>

      </div>

    <hr>
    </div>



    <!--<div class="row">
      <div class="card-columns">
          <div *ngFor="let image of datasource2" class="card">
            <img default="./assets/imgs/no_image.jpg"
                  class="card-img img-fluid" 
                  [srcset] ="image.url" alt="Card image"
                data-toggle="modal" data-target="#selectedImageModal"
                (click)=setSelectedImage(image)>

          </div>
      </div>
  </div>-->
</div>




// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/issues-life/issues-life.component.html